import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
 
import { useSearchParams } from 'react-router-dom';
import { useGetAssetByUrlMutation } from '@/app/Crawl/api/getByUrlApi';
import {
  altColumn,
  protocolColumn,
  ps_urlColumn
} from '../../../config/columns';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { decoder } from '@/helpers/utils';
import useDomain from '@/hooks/useDomain';
// جزییات مربوط به asset های لینک ها که شامل js css image میشود
type ColumnDefinition = Record<string, unknown>;

const AssetsAll = () => {
  const [searchParams] = useSearchParams();
  const { domain_slug } = useDomain();
  useGetUserInfoQuery();
  const [getAssets] = useGetAssetByUrlMutation();
  const columnGenerator = (): ColumnDefinition[] | undefined => {
    // تنظیم ستون ها بر اساس پارامتر  برای دریافت داده مدنظر
    switch (searchParams.get('type')) {
      case 'js':
        return [
          { ...ps_urlColumn(), flex: 1 },
          { ...protocolColumn, flex: 1 }
        ];
      case 'css':
        return [
          { ...ps_urlColumn(), flex: 1 },
          { ...protocolColumn, flex: 1 }
        ];
      case 'image':
        return [
          { ...ps_urlColumn(), flex: 1 },
          { ...protocolColumn, flex: 1 },
          { ...altColumn, flex: 1 }
        ];
      default:
        break;
    }
  };
  return (
    <>
      <AgGridWrapper
         
        fetchFunction={getAssets}
        height="746px"
        columns={columnGenerator()}
        additionalData={{
          job_page: searchParams.get('job_page'),
          domain_slug,
          type: searchParams.get('type') || 'internal',
          asset_url: decoder(
            (searchParams.get('asset_url') || searchParams.get('page_url')) as string
          )
        }}
      />
    </>
  );
};

export default AssetsAll;
